export default {
  aboutTabLegalName: {
    id: 'seller_page_about_tab_legal_name',
    defaultMessage: 'Legal name',
  },
  aboutTabVatNumber: {
    id: 'seller_page_about_tab_vat_number',
    defaultMessage: 'VAT number',
  },
  aboutTabSiretNumber: {
    id: 'seller_page_about_tab_siren_number',
    defaultMessage: 'SIREN number',
  },
  aboutTabAddress: {
    id: 'seller_page_about_tab_legal_address',
    defaultMessage: 'Legal address',
  },
  aboutTabCountryOfOrigin: {
    id: 'seller_page_about_tab_country',
    defaultMessage: "Seller's country of origin",
  },
  konbiniCompanyName: {
    id: 'landing_seller_konbini_company_name',
    defaultMessage: 'Company Name:',
  },
  konbiniStoreName: {
    id: 'landing_seller_konbini_store_name',
    defaultMessage: 'Store Name:',
  },
  landingSellerDescriptionAddress: {
    id: 'landing_seller_description_address',
    defaultMessage: 'Address:',
  },
  konbiniEmail: {
    id: 'landing_seller_konbini_email',
    defaultMessage: 'Email address:',
  },
  konbiniPhoneNumber: {
    id: 'landing_seller_konbini_phone',
    defaultMessage: 'Phone number:',
  },
  konbiniSecondHandDealerNumber: {
    id: 'landing_seller_konbini_secondhand_dealer_number',
    defaultMessage: 'Second hand dealer number:',
  },
  konbiniSecondhandDealerNumberIssuingPrefecture: {
    id: 'landing_seller_konbini_secondhand_dealer_number_issuing_prefecture',
    defaultMessage: 'Secondhand number issuing prefecture:',
  },
  konbiniStoreOperationManager: {
    id: 'landing_seller_konbini_store_operation_manager',
    defaultMessage: 'Business operation manager:',
  },
  konbiniStoreSecurityOfficer: {
    id: 'landing_seller_konbini_store_security_officer',
    defaultMessage: 'Business security officer:',
  },
  konbiniPhoneExplanationNotice: {
    id: 'landing_seller_konbini_phone_explanation_notice',
    defaultMessage: 'Please do not call the seller directly.',
  },
  konbiniBlockTitle: {
    id: 'landing_seller_konbini_block_title',
    defaultMessage:
      'For inquiries, please contact Back Market customer support.',
  },
  konbiniBlockContent: {
    id: 'landing_seller_konbini_block_content',
    defaultMessage:
      'Please refrain from contacting sellers directly as it will be difficult for the support team to provide you with appropriate guidance.',
  },
}
